import ToolbarItem from "toolbar/ToolbarItem";

class ToolbarItemRevisions extends ToolbarItem {

    constructor(onClick, text = "Revisions", icon = "revisions") {
        super();
        this.onClick = onClick;
        this.text = text;
        this.icon = icon;
    }

    handleClick() {
        return this.onClick.apply(this, arguments);
    }

    getText() {
        return this.text;
    }


    getElement() {
        const $element = super.getElement();

        $element.addClass("admin-toolbar__revisions");

        return $element;
    }
}

export default ToolbarItemRevisions;
